require("!!/home/vsts/work/1/s/node_modules/script-loader/addScript.js")(require("!!/home/vsts/work/1/s/node_modules/raw-loader/index.js!/home/vsts/work/1/s/node_modules/html2canvas/dist/html2canvas.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/html2canvas/dist/html2canvas.min.js
// module id = 676
// module chunks = 3